import React, { PropTypes } from 'react';
import classnames from 'classnames';
import ProjectLink from 'common/containers/project_link';
import SubcategoryName from 'common/containers/subcategory_name';
import StarRating from 'common/components/star_rating';

const Review = ({ item, subCategory, stats }) => {
  let author = '';
  if (item.client_name) {
    author += `- ${item.client_name}`;
    if (item.client_title) {
      author += `, ${item.client_title}`;
    }
    if (item.client_company) {
      author += `, ${item.client_company}`;
    }
  }

  const json = {
    "@context": "http://schema.org/",
    "@type": "Review",
    "datePublished":  item.created_at,
    "itemReviewed": {
      "@type": "Product",
      "name": `${subCategory.name} project`,
      "aggregateRating": {
        "ratingValue": stats.avg? stats.avg.toString() : "0.0",
        "reviewCount": stats.count || 0
      }
    },
    "reviewRating": item.publish_rating? {
      "@type": "Rating",
      "ratingValue": item.recommend
    } : undefined,
    "author": {
      "@type": "Person",
      "name": item.client_name
    },
    "reviewBody": item.publish_comment? item.additional_comments : undefined,
    "publisher": {
      "@type": "Organization",
      "name": "crowdspring",
      "sameAs": "https://www.crowdspring.com"
    }
  };
  const scriptTag = `<script type="application/ld+json">${JSON.stringify(json)}</script>`;

  return (
    <ProjectLink target="_blank" project={{
      id: item.project_id,
      slug: item.project_slug,
      sub_category: item.project_sub_category,
    }}>
      <span dangerouslySetInnerHTML={{ __html: scriptTag }} />
      <div className={classnames("item", { "with-photo": item.client_photo })}>
        <div className="sub-category">
          <SubcategoryName id={item.project_sub_category} />
        </div>
        { item.publish_rating &&
        <div className="rating">
          <StarRating readonly={true} initialRate={item.recommend} extraClasses="lg" />
        </div> }
        { item.publish_comment &&
        <div className="comments">{ item.additional_comments }</div> }
        <div className="row">
          <div className={`columns small-${item.client_photo? '11' : '16'}`}>
            <div className="author">{ author }</div>
            <div className="author-location">{ item.client_location }</div>
            { item.publish_project_link &&
            <div className="cta">
              { item.project_client_username }'s
              project <i className="fa fa-long-arrow-right" />
            </div> }
          </div>
          { item.client_photo &&
          <div className="columns small-5">
            <div style={{ backgroundImage: `url("${item.client_photo}")` }}
              className="avatar avatar-lg avatar-round pull-right" />
          </div> }
        </div>
      </div>
    </ProjectLink>
  );
}

Review.propTypes = {
  item: PropTypes.object.isRequired,
  subCategory: PropTypes.object.isRequired,
  stats: PropTypes.object.isRequired,
};

export default Review;
